import styled from 'styled-components';
import { spacings } from 'styles/template/spacings';

export const Container = styled.div`
  margin-bottom: 2rem;
`

export const CardContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  grid-gap: 32px;

  .card-last-item{
    display: flex;

    button{
      margin-left: 2rem;
    }
  }
`